import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import tick from '../resourses/tickbig.png'
import ServicesHeading from '../components/ServicesHeading'
import DividerIcon from '../components/DividerIcon'
import PreFooter from '../components/PreFooter'


const Entregas = props => {
    React.useEffect(() => {
        window.scrollTo(0,0)
    })
    return (
        
        <div>
            <ServicesHeading classToAdd="entregas" subtitle={"La calidad es nuestra prioridad"} 
                title={<>Acompañamos la entrega de principio a fin</>}
                subtitleStyle={{borderRadius: '0 30px 0px 30px'}}
            />
            <DividerIcon />
            <Container className="mt-5">

                <Row>

                    <Col md={12} sm={12} className="text-left">
                        <h5 style={{fontSize:"25px"}} className="greenblue ">
                            
                            ☑  Con <b>tecnología propia</b>  seguimos cada entrega al momento. <br/> 
                            <div class="mt-3"></div>
                            ☑  Verificamos el <b>estado y las condiciones de la carga</b> <br/>
                            y resolvemos cualquier inconveniente en el acto.<br/> 
                            <div class="mt-3"></div>
                            ☑  Nuestros clientes acceden a <b>informes detallados en tiempo real</b>.


                        </h5>
                    </Col>
                   
                </Row>
            </Container>
            
            <Container className="mt-5 pt-3">
                <Row >
                    <Col md={6} className="text-center">
                            <p style={{backgroundColor: '#8f8b0c',  borderRadius: '0 30px 0px 30px', padding: '10px', width:"100%",fontSize: props.width > 769  ? "24px" : "20px" }} className="bold white mb-n1 px-5">Soluciones que ofrecemos</p>
                        
                    </Col >
                    <div className="d-flex justify-content-center" style={{backgroundColor: 'whitesmoke' , width:"100%"  ,flexDirection: props.width <769 ? "column" : "",}}>
                        <div className="px-5 pt-5 pb-4 d-flex w-100 text-sm-left text-md-right">
                                <img src={tick}  style={{objectFit:"contain",width:"25px"}} alt=""/>
                                <p className=" ml-2 mt-1 mb-0 big2">Comunicación directa y constante todos los días del año.</p>
                        </div>
                    </div>
                </Row>
            </Container>
            <Container>
                <Row className="mb-5">
                    <Col className="d-flex justify-content-center">
                        <button onClick={() => window.open("https://www.instagram.com/gualtieriehijos/", '_blank')} 
                        style={{ border: "solid 1px #0E3C39", borderRadius: "0px", backgroundColor: "#0E3C39", fontSize: "1.2rem" }} 
                        className="btn btn-light btn-insta white  mt-5 px-5" > {">"} Conocé más en Instagram</button>
                    </Col>
                </Row>
            </Container>
               <PreFooter />
        </div>
    )
}

export default Entregas